export function ErrorPage() {
  return (
    <div className="mx-auto max-w-xl space-y-4 py-16">
      <header className="space-y-2 font-semibold">
        <div className="text-8xl">:(</div>
        <h1 className="scroll-m-20 font-bitter text-4xl tracking-tight lg:text-5xl">
          Oopsie Woopsie!
        </h1>
      </header>
      <p>
        Uwu We made a fucky wucky!! A wittle fucko boingo! The code monkeys at
        our headquarters are working VEWY HAWD to fix this! If you&apos;d like
        to know more, you can search online later for this error:{" "}
        <code>OOPSIE_WOOPSIE</code>
      </p>
    </div>
  );
}
